import {
    ERROR_RESPONSE,RESET_RESPONSE
  } from "./types"

  const initialState = {
    message:null,
  };
  
  const errorReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case ERROR_RESPONSE:
        return { ...state, message: payload?.errorMessage };
        case RESET_RESPONSE:
        return { ...initialState };
      default:
        return state;
    }
  };
  
  export default errorReducer;
  